webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(10)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(16),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_vue_dist_bootstrap_vue_css__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["a" /* default */]);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CurrentTime__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_CurrentTime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_CurrentTime__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var endAudio = __webpack_require__(12);
var startAudio = __webpack_require__(13);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    CurrentTime: __WEBPACK_IMPORTED_MODULE_0__components_CurrentTime___default.a
  },
  data: function data() {
    return {
      sessionTime: 25,
      sessionCurrentTime: 0,
      sessionDiffMin: '',
      sessionDiffSec: '',
      sessionInt: '',
      breakTime: 5,
      breakCurrentTime: 0,
      breakDiffMin: '',
      breakDiffSec: '',
      breakInt: '',
      circles: 1,
      sessionState: false,
      breakState: false
    };
  },


  methods: {
    startOrPause: function startOrPause() {
      if (!this.circles && !this.sessionCurrentTime) {
        return;
      }
      if (this.sessionInt && this.breakInt && !this.sessionState && !this.breakState && !this.breakCurrentTime && !this.sessionCurrentTime || // call by breakTimer
      !this.sessionInt && !this.breakInt) {
        // first call
        this.circles -= 1;
        this.sessionInt = setInterval(this.sessionTimer, 1000);
        this.sessionState = true;
        this.breakState = false;
        startAudio && new Audio(startAudio).play();
      } else if (this.breakCurrentTime && this.breakState && !this.sessionState) {
        clearInterval(this.breakInt);
        this.breakState = false;
      } else if (this.sessionCurrentTime && this.sessionState && !this.breakState) {
        clearInterval(this.sessionInt);
        this.sessionState = false;
      } else if (this.breakCurrentTime && !this.breakState && !this.sessionState) {
        this.breakInt = setInterval(this.breakTimer, 1000);
        this.breakState = true;
      } else if (this.sessionCurrentTime && !this.sessionState && !this.breakState) {
        this.sessionInt = setInterval(this.sessionTimer, 1000);
        this.sessionState = true;
      }
    },
    stop: function stop() {
      clearInterval(this.sessionInt);
      clearInterval(this.breakInt);

      this.sessionTime = 25;
      this.sessionCurrentTime = 0;
      this.sessionDiffMin = '';
      this.sessionDiffSec = '';

      this.breakTime = 5;
      this.breakCurrentTime = 0;
      this.breakDiffMin = '';
      this.breakDiffSec = '';

      this.circles = 1;

      this.sessionInt = '';
      this.breakInt = '';
      this.sessionState = false;
      this.breakState = false;
    },
    sessionTimer: function sessionTimer() {
      this.sessionCurrentTime += 1000;
      var sessionDiffTime = this.sessionTime * 60 * 1000 - this.sessionCurrentTime;
      this.sessionDiffMin = ('0' + Math.floor(sessionDiffTime / 1000 / 60)).substr(-2);
      this.sessionDiffSec = ('0' + Math.floor(sessionDiffTime / 1000 % 60)).substr(-2);

      if (sessionDiffTime === 0 && this.circles > 0) {
        clearInterval(this.sessionInt);
        this.sessionState = false;
        this.sessionCurrentTime = 0;

        this.breakInt = setInterval(this.breakTimer, 1000);
        this.breakState = true;
        endAudio && new Audio(endAudio).play();
      } else if (sessionDiffTime === 0 && this.circles === 0) {
        endAudio && new Audio(endAudio).play();
        this.stop();
      }
    },
    breakTimer: function breakTimer() {
      this.breakCurrentTime += 1000;
      var breakDiffTime = this.breakTime * 60 * 1000 - this.breakCurrentTime;
      this.breakDiffMin = ('0' + Math.floor(breakDiffTime / 1000 / 60)).substr(-2);
      this.breakDiffSec = ('0' + Math.floor(breakDiffTime / 1000 % 60)).substr(-2);

      if (breakDiffTime === 0) {
        clearInterval(this.breakInt);
        this.breakState = false;
        this.breakCurrentTime = 0;

        this.startOrPause();
      }
    },
    setIntervals: function setIntervals(timer, shift) {
      if (timer === 'session') {
        if (shift === 'minus') {
          this.sessionTime -= 1;
          this.sessionTime = Math.max(this.sessionTime, 1);
        } else {
          this.sessionTime += 1;
          this.sessionTime = Math.min(this.sessionTime, 60);
        }
      } else if (timer === 'break') {
        if (shift === 'minus') {
          this.breakTime -= 1;
          this.breakTime = Math.max(this.breakTime, 1);
        } else {
          this.breakTime += 1;
          this.breakTime = Math.min(this.breakTime, 15);
        }
      } else {
        if (shift === 'minus') {
          this.circles -= 1;
          this.circles = Math.max(this.circles, 1);
        } else {
          this.circles += 1;
          this.circles = Math.min(this.circles, 99);
        }
      }
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'CurrentTime',
  data: function data() {
    return {
      time: '',
      date: ''
    };
  },
  mounted: function mounted() {
    setInterval(this.updateTimeAndDate, 1000);
  },

  methods: {
    updateTimeAndDate: function updateTimeAndDate() {
      var valueDate = new Date();

      this.time = valueDate.toLocaleTimeString();
      this.date = valueDate.toDateString();
    }
  }
});

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 11 */,
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/end.723fb8f.mp3";

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/start.b6d4e2b.mp3";

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(8),
  /* template */
  __webpack_require__(15),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-1062a6e5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 15 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-badge', {
    staticClass: "table-big",
    attrs: {
      "variant": "primary"
    }
  }, [_vm._v("\n    Current time\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.time) + "\n    "), _c('br'), _vm._v("\n    " + _vm._s(_vm.date) + "\n  ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 16 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-card', {
    staticClass: "clock",
    attrs: {
      "header": "Pomodoro Clock",
      "header-variant": "success"
    }
  }, [_c('div', [_c('div', {
    staticClass: "row-disp"
  }, [_c('div', [(_vm.sessionState || _vm.breakState) ? _c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "warning"
    },
    on: {
      "click": _vm.startOrPause
    }
  }, [_c('i', {
    staticClass: "fa fa-pause fa-2x"
  })]) : _c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.startOrPause
    }
  }, [_c('i', {
    staticClass: "fa fa-play fa-2x"
  })])], 1), _vm._v(" "), _c('div', [_c('CurrentTime')], 1), _vm._v(" "), _c('div', [_c('b-button', {
    staticClass: "table-big",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.stop
    }
  }, [_c('i', {
    staticClass: "fa fa-stop fa-2x"
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row-disp"
  }, [_c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('session', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Session time\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.sessionDiffMin) + "\n            :\n            " + _vm._s(_vm.sessionDiffSec) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.sessionTime) + " min(s)\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('session', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('circle', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Circles\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.circles) + "\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('circle', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "btns-table"
  }, [_c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('break', 'minus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-minus"
  })]), _vm._v(" "), _c('b-badge', {
    staticClass: "table-center",
    attrs: {
      "variant": "info"
    }
  }, [_vm._v("\n            Break time\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.breakDiffMin) + "\n            :\n            " + _vm._s(_vm.breakDiffSec) + "\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.breakTime) + " min(s)\n          ")]), _vm._v(" "), _c('b-button', {
    staticClass: "table-btn",
    attrs: {
      "variant": "success",
      "disabled": !!_vm.sessionInt
    },
    on: {
      "click": function($event) {
        _vm.setIntervals('break', 'plus')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  })])], 1)])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.sessionInt) ? _c('b-badge', {
    attrs: {
      "variant": "success"
    }
  }, [_vm._v("On")]) : _c('b-badge', {
    attrs: {
      "variant": "danger"
    }
  }, [_vm._v("Off")])], 1)])], 1)
},staticRenderFns: []}

/***/ })
],[6]);


// WEBPACK FOOTER //
// static/js/app.e9848fb9f2a774daddcf.js